import { render, staticRenderFns } from "./FeaturePopup.vue?vue&type=template&id=0390b7f0&scoped=true"
import script from "./FeaturePopup.vue?vue&type=script&lang=js"
export * from "./FeaturePopup.vue?vue&type=script&lang=js"
import style0 from "./FeaturePopup.vue?vue&type=style&index=0&id=0390b7f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0390b7f0",
  null
  
)

export default component.exports